import type { ReactNode } from "react";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { usePunditUserContext } from "@circle-react/contexts";
import "./BannerBackgrounds.css";

export interface BannerWrapperProps {
  children: ReactNode;
}

const BannerWrapper = ({ children }: BannerWrapperProps) => {
  const { isCommunityOnPlus } = usePlanStatus();
  const { currentCommunitySettings } = usePunditUserContext();

  if (
    isCommunityOnPlus ||
    !currentCommunitySettings?.circle_plus_banners_enabled
  ) {
    return null;
  }

  return <>{children}</>;
};

export default BannerWrapper;
